import React, { useMemo, useCallback } from 'react';
import styled from 'styled-components';
import { IconCheck, Flex } from '@/ui';
import { Typography } from 'antd';

const ConfigureStepsItem = ({
  stepNumber,
  step,
  label,
  currentStep = 0,
  initialStep = 0,
  onClick = null,
  isInProcess,
  adminView = false,
  isInReview
}) => {
  const stepStyles = useMemo(() => {
    if (Array.isArray(step)) {
      if (step === currentStep || step.includes(currentStep)) {
        return {
          color: `#0000FF`
        };
      }
      if (
        Array.isArray(currentStep)
          ? step[step.length - 1] < currentStep[0]
          : step[step.length - 1] < currentStep
      ) {
        return {
          color: `#008000`
        };
      }
      if (
        Array.isArray(currentStep)
          ? step[step.length - 1] > currentStep[0] &&
            currentStep[0] <= initialStep &&
            step[step.length - 1] <= initialStep
          : step[step.length - 1] > currentStep &&
            currentStep <= initialStep &&
            step[step.length - 1] <= initialStep
      ) {
        return {
          color: `#121435`
        };
      }
      return {
        color: '#777984'
      };
    } else {
      if (step === currentStep) {
        return {
          color: `#0000FF`
        };
      }
      if (Array.isArray(currentStep) ? step < currentStep[0] : step < currentStep) {
        return {
          color: `#008000`
        };
      }
      if (
        Array.isArray(currentStep)
          ? step > currentStep[0] && currentStep[0] <= initialStep && step <= initialStep
          : step > currentStep && currentStep <= initialStep && step <= initialStep
      ) {
        return {
          color: `#121435`
        };
      }
      return {
        color: '#777984'
      };
    }
  }, [step, currentStep]);

  const handleClick = useCallback(() => {
    if (onClick && adminView) return onClick();
    if (onClick && isInReview) return onClick();
    if (onClick && isInProcess && initialStep && step <= initialStep) return onClick();
    if (onClick && !isInProcess) return onClick();
    return null;
  }, [step, isInProcess, initialStep]);

  return (
    <>
      <Section
        gap={10}
        $alignCenter
        $onClick={handleClick}
        onClick={handleClick}
        $adminView={adminView}
        $isInProcess={isInProcess}
        $step={step}
        $initialStep={initialStep}
      >
        <div
          style={{
            minWidth: '20px',
            textAlign: 'center'
          }}
        >
          <Typography.Text
            style={{
              whiteSpace: 'nowrap',
              fontSize: '14px',
              ...stepStyles
            }}
          >
            {(
              Array.isArray(step)
                ? Array.isArray(currentStep)
                  ? step[step.length - 1] < currentStep[0]
                  : step[step.length - 1] < currentStep
                : Array.isArray(currentStep)
                  ? step < currentStep[0]
                  : step < currentStep
            ) ? (
              <IconCheck size={20} />
            ) : (
              <span>{stepNumber}</span>
            )}
          </Typography.Text>
        </div>
        <Typography.Text
          style={{
            fontSize: '14px',
            ...stepStyles
          }}
        >
          {label}
        </Typography.Text>
      </Section>
    </>
  );
};

export default ConfigureStepsItem;

const Section = styled(Flex)`
  cursor: ${({ $onClick, $isInProcess, $step, $initialStep, $adminView }) =>
    ($onClick && $adminView) ||
    ($onClick && $isInProcess && $initialStep && $step <= $initialStep) ||
    ($onClick && !$isInProcess)
      ? 'pointer'
      : 'default'};
  &:hover {
    opacity: ${({ $onClick, $isInProcess, $step, $initialStep, $adminView }) =>
      ($onClick && $adminView) ||
      ($onClick && $isInProcess && $initialStep && $step <= $initialStep) ||
      ($onClick && !$isInProcess)
        ? 0.6
        : 1};
  }
`;
